(function (angular) {
	'use strict';

	angular.module('PinMeTo.services').service('pmtSiteService', [
		'$q',
		'$stateParams',
		'auth',
		function ($q, $stateParams, auth) {
			this.site = null;
			this.listeners = [];

			this.getSite = function () {
				return auth.getUser($stateParams.site).then(function (user) {
					return $q.resolve(user.selectedSite);
				});
			};
		}
	]);
})(window.angular);
